/**
 * AppServices
 * Zentrale Registry für Laufzeit-Services (DI-lightweight).
 */

class AppServices {
    constructor(initialServices = {}) {
        this.services = new Map();
        this.registerMany(initialServices);
    }

    register(name, value, options = {}) {
        if (!name || typeof name !== 'string') {
            throw new Error('AppServices.register benötigt einen gültigen Service-Namen');
        }

        this.services.set(name, value);

        const {
            exposeToWindow = false,
            windowKey = name
        } = options || {};

        if (exposeToWindow && typeof window !== 'undefined' && windowKey) {
            window[windowKey] = value;
        }

        return value;
    }

    registerMany(entries = {}, options = {}) {
        if (!entries || typeof entries !== 'object') {
            return;
        }

        Object.entries(entries).forEach(([name, value]) => {
            this.register(name, value, options);
        });
    }

    get(name, fallback = null) {
        if (!name || !this.services.has(name)) {
            return fallback;
        }
        return this.services.get(name);
    }

    has(name) {
        return this.services.has(name);
    }

    remove(name, options = {}) {
        this.services.delete(name);

        const {
            removeFromWindow = false,
            windowKey = name
        } = options || {};

        if (removeFromWindow && typeof window !== 'undefined' && windowKey && Object.prototype.hasOwnProperty.call(window, windowKey)) {
            try {
                delete window[windowKey];
            } catch (_) {
                window[windowKey] = undefined;
            }
        }
    }

    snapshot() {
        const snapshot = {};
        for (const [name, value] of this.services.entries()) {
            snapshot[name] = value;
        }
        return snapshot;
    }
}

export { AppServices };
export const appServices = new AppServices();
